import { NFTTYPE } from '../constants/bakery/nft'

export function userGameNftTypeV1V2(type?: string) {
  let gameType2:any = null
  switch(type){
    case NFTTYPE.BAKEMUSKMIXER:
      gameType2 = NFTTYPE.BAKEMUSKMIXER_V3
      break
    case NFTTYPE.BAKEMUSKMIXER_V3:
      gameType2 = NFTTYPE.BAKEMUSKMIXER
      break
    case NFTTYPE.EQUIPMENT:
      gameType2 = NFTTYPE.EQUIPMENT_V3
      break
    case NFTTYPE.EQUIPMENT_V3:
      gameType2 = NFTTYPE.EQUIPMENT
      break
    case NFTTYPE.POKER_V3:
      gameType2 = NFTTYPE.POKER
      break
    case NFTTYPE.POKER:
      gameType2 = NFTTYPE.POKER_V3
      break
    case NFTTYPE.BARKING_V3:
      gameType2 = NFTTYPE.BARKING
      break
    case NFTTYPE.BARKING:
      gameType2 = NFTTYPE.BARKING_V3
      break
    case NFTTYPE.DOGGIES_V3:
      gameType2 = NFTTYPE.DOGGIES
      break
    case NFTTYPE.DOGGIES:
      gameType2 = NFTTYPE.DOGGIES_V3
      break
    case NFTTYPE.CAR_V3:
      gameType2 = NFTTYPE.CAR
      break
    case NFTTYPE.CAR:
      gameType2 = NFTTYPE.CAR_V3
      break
    case NFTTYPE.SOCCER_V3:
      gameType2 = NFTTYPE.SOCCER
      break
    case NFTTYPE.SOCCER:
      gameType2 = NFTTYPE.SOCCER_V3
      break
    case NFTTYPE.COMBO:
      gameType2 = NFTTYPE.COMBO_V3
      break
    case NFTTYPE.COMBO_V3:
      gameType2 = NFTTYPE.COMBO
      break
  }
  return gameType2
}

export function getStakeType (type: string, stakeLevel: string) {
  let typeConstant:any
    switch (type) {
      case '104':
        if(stakeLevel === 'v1'){
          typeConstant = NFTTYPE.DOGGIES
        }
        if(stakeLevel === 'v2'){
          typeConstant = NFTTYPE.DOGGIES_V3
        }
        break;
      case '117':
        if(stakeLevel === 'v1'){
          typeConstant = NFTTYPE.BAKEMUSKMIXER
        }
        if(stakeLevel === 'v2'){
          typeConstant = NFTTYPE.BAKEMUSKMIXER_V3
        }
        break;
      case '108':
        if(stakeLevel === 'v1'){
          typeConstant = NFTTYPE.BARKING
        }
        if(stakeLevel === 'v2'){
          typeConstant = NFTTYPE.BARKING_V3
        }
        break;
      case '114':
        if(stakeLevel === 'v1'){
          typeConstant = NFTTYPE.EQUIPMENT
        }
        if(stakeLevel === 'v2'){
          typeConstant = NFTTYPE.EQUIPMENT_V3
        }
        break;
      case '106':
        if(stakeLevel === 'v1'){
          typeConstant = NFTTYPE.POKER
        }
        if(stakeLevel === 'v2'){
          typeConstant = NFTTYPE.POKER_V3
        }
        break;
      case '103':
        if(stakeLevel === 'v1'){
          typeConstant = NFTTYPE.CAR
        }
        if(stakeLevel === 'v2'){
          typeConstant = NFTTYPE.CAR_V3
        }
        break;
      case '100':
        if(stakeLevel === 'v1'){
          typeConstant = NFTTYPE.SOCCER
        }
        if(stakeLevel === 'v2'){
          typeConstant = NFTTYPE.SOCCER_V3
        }
        break;
      case 'combo':
        if(stakeLevel === 'v1'){
          typeConstant = NFTTYPE.COMBO
        }
        if(stakeLevel === 'v2'){
          typeConstant = NFTTYPE.COMBO_V3
        }
        break;
    }
    return typeConstant
}
